export default __webpack_public_path__ + "static/media/rc-preview-icon.c059f201.svg";